import React from 'react';
import { FieldValues, useForm } from 'react-hook-form';

import { Select, SpinnerOverlay, SubmissionButtons } from '@components/common';

import { useManageSitesOptions } from '@hooks/useManageSitesOptions';

import { optionsFormattedBySystemId } from '@utils/formatter';

import styles from './LinkCrowdCellForm.module.scss';

export type TLinkCrowdCellFormSubmitHandler = (crowdCellId: string) => void;

interface ILinkCrowdCellFormProps {
	submitHandler: TLinkCrowdCellFormSubmitHandler;
	toggleLinkModal: () => void;
	closeModal: () => void;
	isLoadingRelinkForm: boolean;
}

const LinkCrowdCellForm = ({
	submitHandler,
	toggleLinkModal,
	isLoadingRelinkForm,
}: ILinkCrowdCellFormProps) => {
	const {
		unlinkedCrowdCells,
		isLoadingUnlinkCrowdCellsForm,
	} = useManageSitesOptions();

	const {
		handleSubmit,
		control,
		watch,
		setValue,
	} = useForm<FieldValues>({
		defaultValues: {
			crowdCell: null,
		},
	});

	const isDisabledSubmit = !watch('crowdCell');

	const isDisabled = isDisabledSubmit || isLoadingUnlinkCrowdCellsForm || !!isLoadingRelinkForm;

	const sitesOptions = optionsFormattedBySystemId(unlinkedCrowdCells);

	const onSubmit = (values: FieldValues) => {
		submitHandler(values.crowdCell.value);
		setValue('crowdCell', null);
		toggleLinkModal();
	};

	return (
		<div className={styles.linkCrowdCellFormContainer}>
			{isLoadingUnlinkCrowdCellsForm && <SpinnerOverlay />}
			<Select
				control={control}
				label='Flex-5G'
				name='crowdCell'
				options={sitesOptions}
				placeholder='Select Flex-5G unit'
				required
			/>
			<SubmissionButtons
				disabledPositive={isDisabled}
				negativeHandler={toggleLinkModal}
				positiveHandler={handleSubmit(onSubmit)}
				positiveLabel='Link'
			/>
		</div>
	);
};

export default LinkCrowdCellForm;
